module.exports = __webpack_public_path__ + "img/EXAME-MIDIA.5b3e5aca.png";